<template>
  <div>
    <Main
      :height="height"
      :loading="loading"
      :tableData="tableData"
      :type="type"
      ref="tableMain"
      :tablePage="page"
      @chooseChange="chooseChange"
    >
      <template #header>
        <PageHeader
          ref="header"
          @query="getData"
          @reset="resetPage"
          :checkedCount="checkedCount"
        />
      </template>
      <template #pager>
        <pagination
          size="small"
          align="right"
          slot="pager"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </template>
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'

export default {
  mixins: [BaseTable],
  components: { Main, PageHeader },
  props: {
    height: { type: Number, default: 300 },
    baseInfo: { type: Object, default: () => ({}) },
    type: { type: String, default: 'radio' },
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      usePage: true,
    }
  },
  methods: {
    getData(form) {
      const { customerCode, inspectionFactory } = this.baseInfo
      if (!customerCode || !inspectionFactory) return
      this.loading = true
      this.$api
        .dfInspectionProductOrderGoodsListApi({
          customerCode,
          inspectionFactory,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
    },
    chooseChange(e) {
      this.$emit('chooseChange', e)
    },
    choiceData() {
      return this.$refs.tableMain.choiceData()
    },
  },
}
</script>
